// ============================================================================
// ARABIC TRANSLATIONS - BIBLE FACTS
// ============================================================================
// حقائق مثيرة حول الكتاب المقدس

export const bibleFactsAr = [
  {
    category: "البنية",
    text: "يتكون الكتاب المقدس من 66 سفراً كتبها أكثر من 40 كاتباً على مدى حوالي 1500 عام",
    source: "دراسات الكتاب المقدس"
  },
  {
    category: "الترجمة",
    text: "الكتاب المقدس هو الكتاب الأكثر ترجمة في التاريخ، حيث تُرجم إلى أكثر من 3000 لغة",
    source: "ويكليف لترجمة الكتاب المقدس"
  },
  {
    category: "الآيات",
    text: "يحتوي الكتاب المقدس بأكمله على 31,173 آية، منها 23,214 في العهد القديم و7,959 في العهد الجديد",
    source: "إحصائيات الكتاب المقدس"
  },
  {
    category: "التأثير",
    text: "سفر المزامير هو أطول سفر في الكتاب المقدس ويحتوي على 150 مزموراً، بينما سفر عوبديا هو الأقصر",
    source: "تحليل الكتاب المقدس"
  },
  {
    category: "التاريخ",
    text: "مخطوطات البحر الميت تحتوي على نسخ من الكتاب المقدس من القرن الثالث قبل الميلاد إلى القرن الأول الميلادي، مما يؤكد موثوقية النص الكتابي",
    source: "اكتشافات أثرية"
  },
  {
    category: "الأدب",
    text: "يشمل الكتاب المقدس أنواعاً أدبية متنوعة: التاريخ، الشعر، النبوة، الرسائل، والرؤى",
    source: "التحليل الأدبي"
  },
  {
    category: "العالمية",
    text: "الكتاب المقدس هو الكتاب الأكثر قراءة في التاريخ، حيث يتم توزيع ملايين النسخ سنوياً ويؤثر على جميع الثقافات",
    source: "إحصائيات عالمية"
  }
];

export default bibleFactsAr;
